export default __webpack_public_path__ + "static/media/logo_prefeitura.2e714326.svg";